module.exports = __webpack_public_path__ + "assets/94.jpg?24195ba1d62626c4289f21237387811c";